<template>
  <div class="purchase" v-loading="payPalLoading" element-loading-text="Loading...">
    <errorModal
      v-if="orderFailed"
      v-bind:errorMessage="orderFailMessage"
      v-bind:errorPresent="orderFailed"
      v-bind:close="closeErrorModal"
    />
    <alcoholModal
      v-if="alcoholModalVisible"
      v-bind:clearAlcoholItems="clearAlcoholItems"
      v-bind:toggleAlcoholModal="toggleAlcoholModal"
      v-bind:alcoholItemsToBeRemoved="alcoholItemsToBeRemoved"
    />
    <el-form ref="sizeForm" :rules="rules" :model="sizeForm">
    <div class="complementary hidden-md-and-up">
      <el-collapse accordion v-model="accordionOpen">
        <el-collapse-item name="accordion">
          <template slot="title">
            <svg width="20" height="19" xmlns="http://www.w3.org/2000/svg" class="order-summary-toggle__icon">
              <path
                d="M17.178 13.088H5.453c-.454 0-.91-.364-.91-.818L3.727 1.818H0V0h4.544c.455 0 .91.364.91.818l.09 1.272h13.45c.274 0 .547.09.73.364.18.182.27.454.18.727l-1.817 9.18c-.09.455-.455.728-.91.728zM6.27 11.27h10.09l1.454-7.362H5.634l.637 7.362zm.092 7.715c1.004 0 1.818-.813 1.818-1.817s-.814-1.818-1.818-1.818-1.818.814-1.818 1.818.814 1.817 1.818 1.817zm9.18 0c1.004 0 1.817-.813 1.817-1.817s-.814-1.818-1.818-1.818-1.818.814-1.818 1.818.814 1.817 1.818 1.817z"></path>
            </svg>
            <span v-if="this.accordionOpen === 'accordion'"><span>{{ $t('hideOrderSummary') }}</span></span>
            <span class="order-summary-toggle__total-recap total-recap">
              <span class="total-recap__final-price">${{this.GrandTotal}}</span>
            </span>
          </template>
          <div class="sidebar hidden-md-and-up">
            <div class="sidebar__header"></div>
            <div class="sidebar__content">
              <div class="order-summary order-summary--is-collapsed">
                <h2 class="visually-hidden-if-js">{{ $t('orderSummary') }}</h2>
                <div class="order-summary__sections">
                  <div class="order-summary__section order-summary__section--product-list order-summary__section--is-scrollable">
                    <div class="order-summary__section__content">
                      <table class="product-table">
                        <tr class="product" v-for="(item,index) in this.$store.state.cart.cartProductsList.Sales_Order_Lines">
                          <td class="product__image" @click="goToProductDetail(item)">
                            <div class="product-thumbnail">
                              <div class="product-thumbnail__wrapper">
                                <img :src="item.Thumbnail" alt="">
                              </div>
                              <span class="product-thumbnail__quantity">{{item.Quantity}}</span>
                            </div>
                          </td>
                          <th class="product__description">
                        <span v-if='$i18n.locale=="en"' class="product__description__name order-summary__emphasis">
                         {{productTitle(item)}}
                        </span>
                        <span v-if='$i18n.locale=="ch"' class="product__description__name order-summary__emphasis">
                          {{item.Description}}
                        </span>
                            <span class="product__description__variant order-summary__small-text"></span>
                          </th>
                          <td class="product__price">
                            <span class="order-summary__emphasis">
                              ${{item.TotalPrice.toFixed(2)}}
                            </span>
                          </td>
                        </tr>

                      </table>
                      <div style="display: none" class="order-summary__scroll-indicator">
                        {{ $t('scrollMoreItems') }}
                        <i class="el-icon-bottom"></i>
                      </div>
                    </div>
                  </div>
                  <div class="order-summary__section order-summary__section--discount">
                    <div
                      v-if="this.promoCodeSuccessful && !this.promoCodeLoading && !this.promoCodeValid && this.tag"
                      style='paddingBottom: 10px; marginBottom: 10px;'
                    >
                      <i @click="removePromo($event)" style='color: #ff6600; fontSize: 18px; cursor: pointer' class="far fa-times-circle"></i> <span style='color: #ff6600; fontSize: 18px'>Promo code successful. {{this.tag}}</span>
                    </div>
                    <div v-else-if="this.promoCodeValid && !this.promoCodeSuccessful && !this.promoCodeLoading">
                      <span style='color: #ff6600; fontSize: 18px;'>{{ $t('inputValidPromo') }}</span>
                    </div>
                    <div class="discount" :class="'promoCode' ? 'discountCode' : ''">
                      <el-form-item label="Discount code">
                        <el-input v-model="promoCode"></el-input>
                      </el-form-item>
                      <el-button @click="validatePromotionCode($event)" class="field__input-btn btn">
                        <span class="btn__content visually-hidden-on-mobile">{{ $t('apply') }}</span>
                      </el-button>
                    </div>
                  </div>
                  <div class="order-summary__section order-summary__section--total-lines">
                    <table class="total-line-table">
                      <tbody class="total-line-table__tbody">
                      <tr v-if="business" class="total-line total-line--shipping">
                        <th class="total-line__name">
                          <span>{{ $t('totalWeight') }}</span>
                        </th>
                        <td class="total-line__price">
                      <span class="order-summary__small-text" v-if="this.$store.state.cart.necessaryCartItems.TotalWeight">
                        {{this.$store.state.cart.necessaryCartItems.TotalWeight.toFixed(2)}} lbs.
                      </span>
                        </td>
                      </tr>
                      <tr class="total-line total-line--subtotal">
                        <th class="total-line__name">
                          {{ $t('subtotal') }}
                        </th>
                        <td class="total-line__price">
                          <span class="order-summary__emphasis">
                            ${{this.TotalPrice.toFixed(2)}}
                          </span>
                        </td>
                      </tr>
                      <tr class="total-line total-line--shipping">
                        <th class="total-line__name">
                          <span>{{ $t('shipping') }}</span>
                        </th>
                        <td class="total-line__price">
                      <span class="order-summary__small-text" v-if="this.$store.state.cart.necessaryCartItems.Delivery">
                        ${{this.$store.state.cart.necessaryCartItems.Delivery}}
                      </span>
                        </td>
                      </tr>
                        <tr class="total-line total-line--subtotal">
                        <th class="total-line__name">
                          {{ $t('tax') }}
                        </th>
                        <td class="total-line__price">
                      <span class="order-summary__emphasis">
                        ${{this.necessaryCartItems.Tax}}
                      </span>
                        </td>
                      </tr>
                      <tr v-if="this.$store.state.cart.necessaryCartItems.Surcharge" class="total-line total-line--subtotal">
                        <th class="total-line__name">
                          {{ $t('surcharge') }}
                        </th>
                        <td class="total-line__price">
                        <span class="order-summary__emphasis">
                          ${{this.$store.state.cart.necessaryCartItems.Surcharge}}
                        </span>
                        </td>
                      </tr>
                        <tr class="total-line total-line--subtotal">
                        <th class="total-line__name">
                          {{ $t('promotion') }}
                        </th>
                        <td class="total-line__price">
                      <span class="order-summary__emphasis">
                        -${{this.Savings.toFixed(2)}}
                      </span>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="total-line-table__footer">
                      <tr class="total-line">
                        <th class="total-line__name total_name payment-due-label">
                    <span class="payment-due-label__total">
                      {{ $t('total') }}
                    </span>
                          <span class="payment-due-label__taxes order-summary__small-text hidden">
                      {{ $t('including') }}
                      <span class="">$0.00</span>
                      {{ $t('tax') }}
                    </span>
                        </th>
                        <td class="total-line__price usd_price payment-due">
                      <span class="payment-due__currency">
                        USD
                      </span>
                          <span class="payment-due__price">${{this.necessaryCartItems.GrandTotal}}</span>
                        </td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="wrap">
      <div class="main">
        <div class="receivingWay">
          <el-radio-group v-model="receivingWay" @change="changeReceivingWay">
            <el-radio-button :label="$t('delivery')"></el-radio-button>
            <el-radio-button :label="$t('pick_up')"></el-radio-button>
          </el-radio-group>
        </div>
        <main class="main__content" v-if="receivingWay == 'Delivery' || receivingWay == '运送'">
          <div class="step__sections">
            <div class="section section--shipping-address ">
              <div class="addAddress">
                <div class="section__header__purchase">
                  <h2 class="section__title">{{ $t('deliveryInfo') }}</h2>
                  <div v-if="!addressChoice" class="time_tip"><span>{{ $t('selectAddress') }}</span></div>
                </div>
                <div style="marginBottom: 1em" class="address-container" v-if="addresses.length > 0">
                  <div style="margin: 0.2em" v-for="address in addresses">
                    <el-radio @change="validateDeliveryRadiusCheckout($event)" v-model="addressChoice" :label="address.CustomerDetail_id" :disabled="shipstationLoading">
                      <div class="next-line">
                        <span>{{address.Street + ', ' + address.City + ', ' + address.State + ' ' + address.Zip}}</span>
                      </div>
                    </el-radio>
                  </div>
                </div>
                <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                  <div class="title" :class="isAddAddress?'':'bg_none'" @click="addAddress">
                    <i :class="isAddAddress?'el-icon-minus':'el-icon-plus'"></i><span>{{ $t('addNewAddress') }}</span>
                  </div>
                  <div class="fieldset" v-show="isAddAddress">
                    <div class="field">
                        <div class="two">
                          <div :class="firstName?'firstName':''" class="width">
                            <el-form-item v-bind:label="$t('firstName')" prop="firstName">
                              <el-input v-bind:placeholder="$t('firstName')" v-model="sizeForm.firstName"
                                        @keyup.native="contact"></el-input>
                            </el-form-item>
                          </div>
                          <div :class="lastName?'lastName':''" class="width">
                            <el-form-item v-bind:label="$t('lastName')" prop="lastName">
                              <el-input v-bind:placeholder="$t('lastName')" v-model="sizeForm.lastName"
                                        @keyup.native="contact"></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div :class="address?'address':''">
                          <el-form-item v-bind:label="$t('address')" prop="address">
                            <el-input v-bind:placeholder="$t('addressIncludingApt')" v-model="sizeForm.address"
                                      @keyup.native="contact"></el-input>
                          </el-form-item>
                        </div>
                        <div class="address">
                          <div class="width" :class="phone?'phone':''">
                            <el-form-item v-bind:label="$t('phone')" prop="phone">
                              <el-input v-bind:placeholder="$t('phone')" v-model="sizeForm.phone"
                                        @keyup.native="contact"></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div :class="city?'city':''">
                          <el-form-item v-bind:label="$t('city')" prop="city">
                            <el-input v-bind:placeholder="$t('city')" v-model="sizeForm.city"
                                      @keyup.native="contact"></el-input>
                          </el-form-item>
                        </div>
                        <div class="three">
                          <div class="width_30">
                            <div class="city">
                              <el-form-item v-bind:label="$t('country')" prop="Country">
                                <el-select v-model="sizeForm.Country" value="">
                                  <el-option
                                    v-for="item in CountryList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                  >
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="width_30">
                            <div class="city">
                              <el-form-item v-bind:label="$t('state')" prop="State">
                                <el-select v-model="sizeForm.State" v-bind:placeholder="$t('pleaseSelect')" value="">
                                  <el-option
                                    v-for="item in stateOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                  >
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="width_30">
                            <div :class="code?'code':''">
                              <el-form-item v-bind:label="$t('zipCode')" prop="code">
                                <el-input v-bind:placeholder="$t('zipCode')" v-model="sizeForm.code"
                                          @keyup.native="contact"></el-input>
                              </el-form-item>
                            </div>
                          </div>
                        </div>
                      <button class="place btn" @click="postNewAddress(sizeForm, 'shipping', $event)">{{ $t('saveAddress') }}</button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- here -->
              <div class="shipping-info" style="marginBottom: 17px">
                <h2 class="section__title" style="marginBottom: 7px">
                  {{ $t('shippingInformation') }}
                </h2>
                 <span class="time_tip" v-if="this.b2bOverweight && paymentTerm === 'COD'">Your Order exceeds the normal FedEx Ground threshold. To provide you with the best freight charge your order will be shipped via Less Than Truckload (LTL). Freight quotes will be emailed to you within the next business day. Please let us know if you have any preferences for carrier or delivery service requests. Once we have your approval and freight payment, your order will be sent to the warehouse for processing.</span>
                  <span class="time_tip" v-if="this.b2bOverweight && paymentTerm === 'NET 30' && this.BypassPayment">Your Order exceeds the normal FedEx Ground threshold. To provide you with the best freight charge your order will be shipped via Less Than Truckload (LTL). Freight quotes will be emailed to you within the next business day. Please let us know if you have any preferences for carrier or delivery service requests. Once we have your approval and freight payment, your order will be sent to the warehouse for processing.</span>
                <div v-if="this.business && this.$store.state.cart.necessaryCartItems.TotalWeight > 300">
                  <p style="marginBottom: 3px">Elegant Granite recommends LTL (Less than truck load) shipping for your order:</p>
                  <span @click="shippingInfoModalOpen = true; shippingInfoModalIdx = 1" class="shipping-info-ltl">• Reduce risk of damage</span>
                  <br>
                  <span @click="shippingInfoModalOpen = true; shippingInfoModalIdx = 2" class="shipping-info-ltl">• Reduce shipping cost</span>
                  <br>
                  <span @click="shippingInfoModalOpen = true; shippingInfoModalIdx = 4" class="shipping-info-ltl">• White glove services are available for a nominal fee</span>
                </div>
                <transition name="modal" v-if="shippingInfoModalOpen">
                  <div class="modal-mask" @click="shippingInfoModalOpen = false">
                    <div class="modal-wrapper">
                      <div class="modal-container1" @click.stop>
                        <div>
                          <div class="text-center">
                            <span v-if="shippingInfoModalIdx === 1" class="title" >{{ $t('shippingInfoTitle1') }}</span>
                            <p v-if="shippingInfoModalIdx === 1" class="info" >{{ $t('shippingInfoDesc1') }}</p>
                            <span v-if="shippingInfoModalIdx === 2" class="title" >{{ $t('shippingInfoTitle2') }}</span>
                            <p v-if="shippingInfoModalIdx === 2" class="info" >{{ $t('shippingInfoDesc2') }}</p>
                            <span v-if="shippingInfoModalIdx === 4" class="title" >{{ $t('shippingInfoTitle4') }}</span>
                            <p v-if="shippingInfoModalIdx === 4" class="info" >{{ $t('shippingInfoDesc4') }}<span style="color:blue"> uscabinetsworld@gmail.com</span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
                <span :style="'font-size: 12px'"  v-if="this.business && this.shipstationError">{{shipstationError}}. Please refresh the page and try again.</span>
                <span :style="'font-size: 12px'"  v-else-if="this.shipstationError">{{shipstationError}}. Please refresh the page and try again2.</span>
                  <div class="shipping-selection">
                    <div v-if="this.shipstationLoading" class="svg">
                      <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        width="120px" height="120px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                        <path fill="black" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                          <animateTransform attributeType="xml"
                            attributeName="transform"
                            type="rotate"
                            from="0 25 25"
                            to="360 25 25"
                            dur="1s"
                            repeatCount="indefinite"
                          />
                        </path>
                      </svg>
                    </div>
                    <div class="shipstation-container" v-else-if="this.shipstationSuccess || !this.shipstationLoading && !this.b2bOverweight" v-for="(item, index) in shipstationResults">
                      <div class="radio-container">
                        <el-radio @change="selectShipstation($event, item)" style="border: 0; width: 100%; height: 1em;" :label="item" v-model="shipstation" >
                          <span>{{item.serviceName}}</span>
                        </el-radio>
                        <div class="shipstation-cost-container">
                          <span v-if="TotalPrice <= 30" :style="'font-size: 16px'" >${{ (item.shipmentCost + item.otherCost).toFixed(2)}}</span>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
        <div v-if="!BypassPayment" class="addPayment">
          <div class="section__header">
            <h2 class="section__title"></h2>
          </div>
        <!-- <header class="main__header hidden-sm-and-down"> -->
          <h2 class="section__title">{{ $t('choosePaymentMethod') }}</h2>
            <span class="time_tip" v-if="(paymentMethod === 'paypal' || paymentMethod === 'creditcard') && this.business">There is a 3% service charge for this payment method.</span>
            <span class="time_tip" v-if="paymentMethod === 'ACH'">Please allow up to 1 to 2 business days for your payment to be processed. You will receive a follow up email (with a tracking number) once your order has been shipped.</span>
          <div v-show="!addressChoice && showPaymentError" class="time_tip__purchase">
            <span class="error-message">{{ $t('chooseValidAddressPay') }}</span>
          </div>
          <div class="payment-container" v-bind:style="{marginBottom: 10 + 'px'}">
            <div class="payment-container" v-if="!addressChoice" @click="showPaymentError=true">
<!--              <el-radio-->
<!--                v-if="!this.business"-->
<!--                style="display: flex; flex-direction: row; justify-content: center; align-items: center"-->
<!--                className="radio-purchase"-->
<!--                :disabled="!addressChoice || shipstationLoading || shipstationError"-->
<!--                v-model="paymentMethod"-->
<!--                v-bind:label="$t('alipay')"-->
<!--              >-->
<!--                <span>-->
<!--                  <i class="fab fa-alipay fa-3x" style="color: #C0C4CC;"></i>-->
<!--                </span>-->
<!--              </el-radio>-->
<!--              <el-radio-->
<!--                v-if="!this.business"-->
<!--                style="display: flex; flex-direction: row; justify-content: center; align-items: center"-->
<!--                className="radio-purchase"-->
<!--                :disabled="!addressChoice || shipstationLoading || shipstationError"-->
<!--                v-model="paymentMethod"-->
<!--                v-bind:label="$t('wechatpay')"-->
<!--              >-->
<!--                <span>-->
<!--                  <i class="fab fa-weixin fa-3x" style="color: #C0C4CC;"></i>-->
<!--                </span>-->
<!--              </el-radio>-->
<!--            	<el-radio-->
<!--                v-if="!this.b2bOverweight"-->
<!--                className="radio-purchase"-->
<!--                style="display: flex; flex-direction: row; justify-content: center; align-items: center"-->
<!--                :disabled="!addressChoice || shipstationLoading || shipstationError"-->
<!--                v-model="paymentMethod"-->
<!--                v-bind:label="$t('paypal')"-->
<!--              >-->
<!--                <span>-->
<!--                  <i class="fab fa-cc-paypal fa-3x" style="color: #C0C4CC;"></i>-->
<!--                </span>-->
<!--              </el-radio>-->
              <el-radio
                v-if="!this.b2bOverweight"
                style="display: flex; flex-direction: row; justify-content: center; align-items: center" className="radio-purchase"
                :disabled="!addressChoice || shipstationLoading || shipstationError"
                v-model="paymentMethod"
                v-bind:label="$t('creditcard')"
              >
                <div class="ach-radio-disabled-cc">
                  <a class="ach-radio-text-disabled-cc">Credit</a>
                  <a class="ach-radio-text-disabled-cc">Card</a>
                </div>
              </el-radio>

              <el-radio
                v-if="this.business"
                style="display: flex; flex-direction: row; justify-content: center; align-items: center"
                className="radio-purchase"
                :disabled="!addressChoice || shipstationLoading"
                v-model="paymentMethod"
                label="ACH"
              >
                <div class="ach-radio-disabled">
                  <a class="ach-radio-text-disabled">ACH</a>
                </div>
              </el-radio>
            </div>
            <div class="payment-container" v-else>
<!--              <el-radio v-if="!this.business" className="radio-purchase" style="display: flex; flex-direction: row; justify-content: center; align-items: center" :disabled="shipstationLoading" v-model="paymentMethod" label="alipay"><span><i class="fab fa-alipay fa-3x" style="color: #0e9dec"></i></span></el-radio>-->
<!--              <el-radio v-if="!this.business" style="display: flex; flex-direction: row; justify-content: center; align-items: center" className="radio-purchase" :disabled="shipstationLoading" v-model="paymentMethod" label="wechatpay"><span><i class="fab fa-weixin fa-3x" style="color: #09B83E"></i></span></el-radio>-->
<!--              <el-radio-->
<!--                v-if="!this.b2bOverweight"-->
<!--                style="display: flex; flex-direction: row; justify-content: center; align-items: center" className="radio-purchase-paypal" :disabled="shipstationLoading || shipstationError" v-model="paymentMethod" label="paypal"><span><i class="fab fa-cc-paypal fa-3x" style="color: black"></i></span></el-radio>-->

              <el-radio
                v-if="!this.b2bOverweight"
                style="display: flex; flex-direction: row; justify-content: center; align-items: center" className="radio-purchase"
                :disabled="shipstationLoading"
                v-model="paymentMethod"
                label="creditcard"
              >
                <div class="ach-radio-cc">
                  <a class="ach-radio-text-cc">Credit</a>
                  <a class="ach-radio-text-cc">Card</a>
                </div>
              </el-radio>

              <el-radio style="display: flex; flex-direction: row; justify-content: center; align-items: center" v-if="this.business" className="radio-purchase" :disabled="shipstationLoading" v-model="paymentMethod" label="ACH"><div class="ach-radio"><a class="ach-radio-text">ACH</a></div></el-radio>
            </div>
          </div>
        <!-- </header> -->
        <!-- <div v-if="!this.cardLoading && this.cardSuccess"><h3>{{ $t('cardSubmitSuccess') }}</h3></div> -->
          <div v-if="paymentMethod === 'creditcard' && !this.cardLoading && this.addressChoice" class="section__content">
            <div class="title" :class="isAddPayment?'':'bg_none'" @click="addPayment()">
              <i :class="isAddPayment?'el-icon-minus':'el-icon-plus'"></i><span>{{ $t('addPayment') }}</span>
            </div>
            <div class="fieldset" v-show="isAddPayment">
              <div class="field">
                <div :class="address?'address':''">
                  <el-form-item v-bind:label="$t('cardHolderName')" prop="card_holder_name">
                    <el-input
                      v-bind:placeholder="$t('cardHolderName')"
                      v-model="sizeForm.card_holder_name"
                      @keyup.native="contact">
                    </el-input>
                  </el-form-item>
                  </div>
                  <div :class="address?'address':''">
                    <el-form-item v-bind:label="$t('creditCardNumber')" prop="Card">
                      <el-input v-bind:placeholder="$t('creditCardNumber')" v-model="sizeForm.Card" @input="cardNumberFormatter(sizeForm.Card)"
                                @keyup.native="contact">
                      </el-input>
                    </el-form-item>
                  </div>
                  <div class="two">
                    <div :class="firstName?'firstName':''" class="width">
                      <el-form-item v-bind:label="$t('cardExpiration')" prop="Expiration">
                        <el-input v-bind:placeholder="$t('cardExpiration')"
                          v-model="sizeForm.Expiration"
                          @input="cardExpireDateFormatter(sizeForm.Expiration)"
                          @keyup.native="contact"
                          :maxlength="5"
                        />
                      </el-form-item>
                    </div>
                    <div :class="lastName?'lastName':''" class="width">
                      <el-form-item v-bind:label="$t('cvc')" prop="CVC">
                        <el-input
                          v-bind:placeholder="$t('cvc')"
                          v-model="sizeForm.CVC"
                          @keyup.native="contact"
                          :maxlength="4"
                        />
                      </el-form-item>
                    </div>
                  </div>
              </div>
              <div class="billing_address_selection">
                  <!-- <div v-if="this.business" class="time_tip"><span>{{ $t('selectBillingAddress') }}</span></div>
                  <el-checkbox v-if="this.business" v-model="billingAddressSame">Same as Shipping Address</el-checkbox>
                  <div v-if="!this.business" class="time_tip"><span>{{ $t('selectBillingAddressNote') }}</span></div> -->
                  <div class="time_tip"><span>{{ $t('selectBillingAddress') }}</span></div>
                  <el-checkbox v-model="billingAddressSame">Same as Shipping Address</el-checkbox>
              </div>
              <div v-if="!billingAddressSame && addresses.length > 0" style="marginBottom: 1em" class="address-container">
                <div style="margin: 0.2em" v-for="address in addresses">
                  <el-radio @change="validateDeliveryRadiusCheckout($event)" v-model="billingAddress" :label="address">
                    <div class="next-line">
                      <span>{{address.Street + ', ' + address.City + ', ' + address.State + ' ' + address.Zip}}</span>
                    </div>
                  </el-radio>
                </div>
              </div>
              <div v-if="!billingAddressSame" class="addAddress">
                <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                  <div class="title" :class="isAddBilling?'':'bg_none'" @click="addBilling">
                    <i :class="isAddBilling?'el-icon-minus':'el-icon-plus'"></i><span>{{ $t('addNewAddress') }}</span>
                  </div>
                  <div class="fieldset" v-show="isAddBilling">
                    <div class="field">
                        <div class="two">
                          <div :class="firstName?'firstName':''" class="width">
                            <el-form-item v-bind:label="$t('firstName')" prop="firstName">
                              <el-input v-bind:placeholder="$t('firstName')" v-model="sizeForm.firstName"
                                        @keyup.native="contact"></el-input>
                            </el-form-item>
                          </div>
                          <div :class="lastName?'lastName':''" class="width">
                            <el-form-item v-bind:label="$t('lastName')" prop="lastName">
                              <el-input v-bind:placeholder="$t('lastName')" v-model="sizeForm.lastName"
                                        @keyup.native="contact"></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div :class="address?'address':''">
                          <el-form-item v-bind:label="$t('address')" prop="address">
                            <el-input v-bind:placeholder="$t('addressIncludingApt')" v-model="sizeForm.address"
                                      @keyup.native="contact"></el-input>
                          </el-form-item>
                        </div>
                        <div class="address">
                          <div class="width" :class="phone?'phone':''">
                            <el-form-item v-bind:label="$t('phone')" prop="phone">
                              <el-input v-bind:placeholder="$t('phone')" v-model="sizeForm.phone"
                                        @keyup.native="contact"></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div :class="city?'city':''">
                          <el-form-item v-bind:label="$t('city')" prop="city">
                            <el-input v-bind:placeholder="$t('city')" v-model="sizeForm.city"
                                      @keyup.native="contact"></el-input>
                          </el-form-item>
                        </div>
                        <div class="three">
                          <div class="width_30">
                            <div class="city">
                              <el-form-item v-bind:label="$t('country')" prop="Country">
                                <el-select v-model="sizeForm.Country" value="">
                                  <el-option
                                    v-for="item in CountryList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                  >
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="width_30">
                            <div class="city">
                              <el-form-item v-bind:label="$t('state')" prop="State">
                                <el-select v-model="sizeForm.State" v-bind:placeholder="$t('pleaseSelect')" value="">
                                  <el-option
                                    v-for="item in stateOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                  >
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="width_30">
                            <div :class="code?'code':''">
                              <el-form-item v-bind:label="$t('zipCode')" prop="code">
                                <el-input v-bind:placeholder="$t('zipCode')" v-model="sizeForm.code"
                                          @keyup.native="contact"></el-input>
                              </el-form-item>
                            </div>
                          </div>
                        </div>
                      <button class="place btn" @click="postNewAddress(sizeForm, 'billing', $event)">{{ $t('saveBillingAddress') }}</button>
                    </div>
                  </div>
                </div>
              </div>
                <span v-show="cardError" style="color:red">{{cardError}}</span>
                <el-button :disabled="!this.cardName || !this.cardCvc || !this.cardExpiry || !this.cardNum" @click="fetchCardToken()" class="place btn " >{{ $t('submitCardInfo') }}</el-button>
            </div>
          </div>
          <div v-if="paymentMethod === 'ACH' && this.addressChoice" class="section__content">
            <div class="title" :class="isAddBankInfo ?'':'bg_none'" @click="addBank()">
              <i :class="isAddBankInfo ?'el-icon-minus':'el-icon-plus'"></i><span>{{ $t('addBank') }}</span>
            </div>
            <div class="fieldset" v-show="isAddBankInfo">
              <a v-if="this.achData.length" class="time_tip">Select a saved ACH account.</a>
            <div style="marginBottom: 1em" class="address-container" v-if="achData.length > 0">
              <div style="margin: 0.2em" v-for="profile in achData">
                <el-radio @change="achSelected($event)" v-model="achChoice" :label="profile">
                  <div class="next-line">
                    <span>Account Number: {{profile.account_num}}</span>
                  </div>
                </el-radio>
              </div>
            </div>
              <div class="section__content">
                <div class="title" :class="isAddBankForm ?'':'bg_none'" @click="addBankForm()">
                <i :class="isAddBankForm ?'el-icon-minus':'el-icon-plus'"></i><span>{{ $t('addBankForm') }}</span>
              </div>
              <div class="fieldset" v-show="this.isAddBankForm">
                <div class="field">
                  <div :class="address?'address':''">
                    <el-form-item v-bind:label="$t('bank_name')" prop="bankName">
                      <el-input
                        @keyup.native="contact"
                        v-model="sizeForm.bankName"
                        v-bind:placeholder="$t('bank_name')"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item v-bind:label="$t('Routing_Number')" prop="routing" >
                      <el-input
                        v-bind:placeholder="$t('Routing_Number')"
                        v-model="sizeForm.routing"
                        @keyup.native="contact"
                      />
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item v-bind:label="$t('Account_number')" prop="account">
                      <el-input
                        v-bind:placeholder="$t('Account_number')"
                        v-model="sizeForm.account"
                        @keyup.native="contact"
                      />
                    </el-form-item>
                  </div>
                  <span class="time_tip">Please CLICK submit bank info before place an order.</span>
                  <el-button :disabled="(!this.sizeForm.bankName || !this.sizeForm.routing || !this.sizeForm.account) && !this.achChoice" @click="fetchBankInfo()" class="place btn " >{{ $t('submitBankInfo') }}</el-button>
                </div>
                </div>
              </div>
              <span v-show="cardError" style="color:red">{{cardError}}</span>
              <!-- <el-button :disabled="(!this.sizeForm.bankName || !this.sizeForm.routing || !this.sizeForm.account) && !this.achChoice" @click="fetchBankInfo()" class="place btn " >{{ $t('submitBankInfo') }}</el-button> -->
            </div>
          </div>
          <div v-if="paymentMethod === 'ACH' && this.addressChoice && windowWidth >= 550">
              <img src="../assets/img/checkexample.png" alt="">
          </div>
          <div v-if="paymentMethod === 'ACH' && this.addressChoice && windowWidth < 550">
              <img style="width: 250px; height: 125px;" src="../assets/img/checkexample.png" alt="">
          </div>
          <div v-else-if="this.cardLoading" class="svg">
            <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              width="120px" height="120px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
              <path fill="black" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                <animateTransform attributeType="xml"
                  attributeName="transform"
                  type="rotate"
                  from="0 25 25"
                  to="360 25 25"
                  dur="1s"
                  repeatCount="indefinite"
                />
              </path>
            </svg>
          </div>
          <!-- <div v-else-if="!this.cardLoading && this.cardSuccess"><h3>{{ $t('cardSubmitSuccess') }}</h3></div> -->
            </div>
          <span v-show="cardError" style="color:red">{{cardError}}</span>
            </div>
          </div>
        </main>
        <div style="padding-top: 3em;" v-if="receivingWay == 'Pick Up' || receivingWay == '自取'">
          <div style="marginBottom: 1em" class="address-container" v-if="addresses.length > 0">
            <div style="margin: 0.2em" v-for="address in addresses">
                <div class="next-line">
                  <span>{{address.Street + ', ' + address.City + ', ' + address.State + ' ' + address.Zip}}</span>
                </div>
            </div>
          </div>
        </div>
        <footer class="main__footer">
          <div v-if="this.necessaryCartItems.AvailableCredit !== 0 && this.userDetails.PaymentTerm !== `NET 30`">
            <h2 class="section__title hidden">{{ $t('userCredit') }}</h2>
            <div style="marginTop: 20px; marginBottom: 20px">
              <el-checkbox v-model="IsCreditUsed" :disabled="!addressChoice || shipstationLoading"></el-checkbox>
              <span style="marginLeft: 10px; fontSize: 17px">{{ $t('use_my_credit_balance') }} <span style="color: red">(${{this.necessaryCartItems.AvailableCredit}})</span></span>
            </div>
          </div>
          <div v-if="windowWidth >= 992 && !this.promoCodeLoading" >
            <h2 class="section__title">{{ $t('discount') }}</h2>
            <div
              v-if="this.promoCodeSuccessful && !this.promoCodeLoading && !this.promoCodeValid && this.tag"
              style='paddingBottom: 10px; marginBottom: 10px;'
            >
              <i @click="removePromo($event)" style='color: #ff6600; fontSize: 18px; cursor: pointer' class="far fa-times-circle"></i> <span style='color: #ff6600; fontSize: 18px'>Promo code successful. {{this.tag}}</span>
            </div>
            <div v-else-if="this.promoCodeValid && !this.promoCodeSuccessful && !this.promoCodeLoading" style='paddingBottom: 10px; marginBottom: 10px;'>
              <span style='color: #ff6600; fontSize: 18px'>{{ this.promoCodeValid}}</span>
            </div>
            <div class="discount" :class="promoCode ? 'discountCode' : ''">
              <el-form-item v-bind:label="$t('discountCode')" >
                <el-input
                  v-bind:placeholder="$t('discountCode')"
                  v-model="promoCode"
                  @keyup.native="contact"
                ></el-input>
              </el-form-item>
              <button class="place btn" @click="validatePromotionCode($event)">{{ $t('apply') }}</button>
            </div>
          </div>
          <div v-else-if="windowWidth >= 992 && this.promoCodeLoading && !this.promoCodeSuccessful" class="svg">
            <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              width="120px" height="120px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
              <path fill="black" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                <animateTransform attributeType="xml"
                  attributeName="transform"
                  type="rotate"
                  from="0 25 25"
                  to="360 25 25"
                  dur="1s"
                  repeatCount="indefinite"
                />
              </path>
            </svg>
          </div>
	         <el-button v-show="this.paymentMethod !== 'paypal' && windowWidth < 992" :disabled="!isFormValidForSubmission()" @click="onSubmit('sizeForm')" class="place btn" >{{ $t('placeOrder') }}</el-button>
        </footer>
        <div v-show="paymentMethod === 'paypal' && windowWidth <= 990  && paypalValidationError === false" style="marginTop: 10px;" id="button-1"></div>
        <el-button v-if="this.paymentMethod === 'paypal' && paypalValidationError === true" :disabled="true" class="place btn hidden-md-and-up" style="marginTop: 10px;">{{ $t('placeOrder') }}</el-button>
        <div v-if="this.paymentMethod === 'paypal' && this.paypalValidationError === true">
          <span class="error-message">
            Error: {{this.paypalValidationErrorMsg}}
          </span>
        </div>
    </div>
      <div class="sidebar hidden-sm-and-down">
        <div class="sidebar__header"></div>
        <div class="sidebar__content">
          <div class="order-summary order-summary--is-collapsed">
            <h2 class="visually-hidden-if-js">{{ $t('orderSummary') }}</h2>
            <div class="order-summary__sections">
              <div class="order-summary__section order-summary__section--product-list order-summary__section--is-scrollable" ref="infoBox">
                <div class="order-summary__section__content">
                  <table class="product-table">
                    <tr class="product" v-for="(item,index) in this.$store.state.cart.cartProductsList.Sales_Order_Lines">
                      <td @click="goToProductDetail(item)" class="product__image">
                        <div class="product-thumbnail">
                          <div class="product-thumbnail__wrapper">
                            <img :src="item.Thumbnail" alt="">
                          </div>
                          <span class="product-thumbnail__quantity">{{item.Quantity}}</span>
                        </div>
                      </td>
                      <th class="product__description">
                        <span v-if='$i18n.locale=="en"' class="product__description__name order-summary__emphasis">
                          {{productTitle(item)}}
                        </span>
                        <span v-if='$i18n.locale=="ch"' class="product__description__name order-summary__emphasis">
                          {{item.Description}}
                        </span>
                        <span class="product__description__variant order-summary__small-text"></span>
                      </th>
                      <td class="product__price">
                        <span class="order-summary__emphasis">
                          ${{item.TotalPrice.toFixed(2)}}
                        </span>
                      </td>
                    </tr>
                  </table>
                  <div style="display: none" class="order-summary__scroll-indicator">
                    {{ $t('scrollMoreItems') }}
                    <i class="el-icon-bottom"></i>
                  </div>
                </div>
              </div>
              <div v-if="this.$store.state.cart.necessaryCartItems.Promotions && this.$store.state.cart.necessaryCartItems.Promotions.length > 0" class="order-summary__section order-summary__section--product-list order-summary__section--is-scrollable" ref="promoInfoBox">
                <div class="promo-summary__section__content">
                  <p class="promo-summary__small-text">{{ $t('promotion') }}</p>
                  <table class="product-table">
                    <tr class="product" v-for="(item,index) in this.$store.state.cart.necessaryCartItems.Promotions">
                      <td class="product__image">
                        <div class="product-thumbnail">
                          <div class="product-thumbnail__wrapper">
                            <img :src="item.Thumbnail" alt="">
                          </div>
                          <span class="product-thumbnail__quantity">{{item.Quantity}}</span>
                        </div>
                      </td>
                      <th class="product__description">
                        <span v-if='$i18n.locale=="en"' class="product__description__name order-summary__emphasis">
                          {{productTitle(item)}}
                        </span>
                        <span v-if='$i18n.locale=="ch"' class="product__description__name order-summary__emphasis">
                          {{item.Description}}
                        </span>
                        <span class="product__description__variant order-summary__small-text"></span>
                      </th>
                      <td class="product__price">
                        <span class="promo-summary__free">
                          {{ $t('free') }}
                        </span>
                      </td>
                    </tr>
                  </table>
                  <div style="display: none" class="order-summary__scroll-indicator">
                    {{ $t('scrollMoreItems') }}
                    <i class="el-icon-bottom"></i>
                  </div>
                </div>
              </div>
              <div class="order-summary__section order-summary__section--total-lines"  :class="this.validateScrollPosition()" >
                <table class="total-line-table">
                  <tbody class="total-line-table__tbody">
                      <tr v-if="business" class="total-line total-line--shipping">
                        <th class="total-line__name">
                          <span>{{ $t('totalWeight') }}</span>
                        </th>
                        <td class="total-line__price">
                        <span class="order-summary__small-text" v-if="this.$store.state.cart.necessaryCartItems.TotalWeight">
                          {{this.$store.state.cart.necessaryCartItems.TotalWeight.toFixed(2)}} lbs.
                        </span>
                        </td>
                      </tr>
                  <tr class="total-line total-line--subtotal">
                    <th class="total-line__name">
                      {{ $t('subtotal') }}
                    </th>
                    <td class="total-line__price">
                      <span class="order-summary__emphasis">
                        ${{this.TotalPrice.toFixed(2)}}
                      </span>
                    </td>
                  </tr>
                  <tr class="total-line total-line--subtotal">
                    <th class="total-line__name">
                      Tax
                    </th>
                    <td class="total-line__price">
                      <span class="order-summary__emphasis">
                        ${{this.necessaryCartItems.Tax}}
                      </span>
                    </td>
                  </tr>
                  <tr class="total-line total-line--shipping">
                    <th class="total-line__name" style="paddingRight: 0">
                      <span>{{ $t('shipping') }}</span>
                      <span class="shipping-note" v-show="false">{{ $t('reach30') }}
                      </span>
                    </th>
                    <td class="total-line__price">
                      <span v-if="!business && TotalPrice >= 30 && shipstation" class="order-summary__small-text">
                        ${{shippingMethod === 'Delivery' ? shipstation.shipmentCost : 0}}
                      </span>
                      <span v-else-if="!this.b2bOverweight && this.$store.state.cart.necessaryCartItems.Delivery" class="order-summary__small-text">
                        ${{this.$store.state.cart.necessaryCartItems.Delivery.toFixed(2)}}
                      </span>
                      <span v-else-if="this.b2bOverweight" :style="'color: red'">See Shipping Info</span>
                    </td>
                  </tr>
                  <tr class="total-line total-line--subtotal">
                    <th class="total-line__name">
                      {{ $t('promotion') }}
                    </th>
                    <td class="total-line__price">
                    <span class="order-summary__emphasis">
                      -${{this.Savings.toFixed(2)}}
                    </span>
                    </td>
                  </tr>
                    <tr v-if="this.$store.state.cart.necessaryCartItems.Surcharge" class="total-line total-line--subtotal">
                      <th class="total-line__name">
                        {{ $t('surcharge') }}
                      </th>
                      <td class="total-line__price">
                      <span class="order-summary__emphasis">
                        ${{this.$store.state.cart.necessaryCartItems.Surcharge}}
                      </span>
                      </td>
                    </tr>
                    <tr v-if="this.IsCreditUsed === true" class="total-line total-line--subtotal">
                      <th class="total-line__name">
                        {{ $t('credit') }}
                      </th>
                      <td class="total-line__price">
                      <span class="order-summary__emphasis">
                        -${{this.necessaryCartItems.CreditAmount}}
                      </span>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot class="total-line-table__footer">
                  <tr class="total-line">
                    <th class="total-line__name total_name payment-due-label">
                    <span class="payment-due-label__total">
                      {{ $t('total') }}
                    </span>
                      <span class="payment-due-label__taxes order-summary__small-text hidden">
                      {{ $t('including') }}
                      <span class="">$0.00</span>
                      {{ $t('tax') }}
                    </span>
                    </th>
                    <td class="total-line__price usd_price payment-due">
                      <span class="payment-due__currency">
                        USD
                      </span>
                      <span class="payment-due__price">${{this.necessaryCartItems.GrandTotal}}</span>
                    </td>
                  </tr>
                  </tfoot>
                </table>
                <el-button v-if="this.paymentMethod !== 'paypal'" :disabled="!isFormValidForSubmission()"  @click="onSubmit('sizeForm')" class="place btn " style="marginTop: 10px;">{{ $t('placeOrder') }}</el-button>
                <div v-show="paymentMethod === 'paypal' && paypalValidationError === false" style="marginTop: 10px;" id="button-2"></div>
                <el-button v-if="this.paymentMethod === 'paypal' && paypalValidationError === true" :disabled="true" class="place btn" style="marginTop: 10px;">{{ $t('placeOrder') }}</el-button>
                <div v-if="this.paymentMethod === 'paypal' && this.paypalValidationError === true">
                  <span class="error-message">
                    Error: {{this.paypalValidationErrorMsg}}
                  </span>
                </div>
                <!-- <div v-if="this.orderFailed">
                  <span v-if="this.orderFailMessage && this.orderFailMessage !== ''" class="error-message">
                    Error: {{this.orderFailMessage}}
                  </span>
                  <span v-if="!this.orderFailMessage || this.orderFailMessage === ''" class="error-message">
                    Error: {{ $t('clearCache') }}
                  </span>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--提示框-->
    <div class="refundContent">
      <el-dialog
        title="Refund policy"
        :visible.sync="this.refund"
        width="90%"
        :before-close="refundShow">
        <p>Refund Policy</p>
        <p>A refund, or credit, for the cost of unopened merchandise, less a 15% restocking fee, will be issued when
          merchandise is returned within 10 days of receipt. Shipping cost will only be refunded if the return is due to
          an error made by J Town Express.</p>
        <p>Please note: J Town Express is not responsible for items opened or damaged due to high pressure/altitude.
          These items will not be refunded or accepted for return.</p>
        <p>Out of Stock Items</p>
        <p>Due to J Town Express's large variety of items and constant volume of sales, occasionally, items listed for
          sale on the e-store may be out of stock. J Town Express will issue an immediate refund for items ordered but
          currently not in stock.</p>
      </el-dialog>
    </div>
    <div class="privacyContent">
      <el-dialog
        title="Privacy policy"
        :visible.sync="this.privacy"
        width="90%"
      >
        <p>Privacy Notice</p>
        <p>This privacy notice discloses the privacy practices for jtownexpress.com. This privacy notice applies solely
          to information collected by this web site. It will notify you of the following:</p>
        <p>What personally identifiable information is collected from you through the web site, how it is used and with
          whom it may be shared.</p>
        <p>What choices are available to you regarding the use of your data.</p>
        <p>The security procedures in place to protect the misuse of your information. How you can correct any
          inaccuracies in the information.</p>
        <p>Information Collection, Use, and Sharing</p>
        <p>We are the sole owners of the information collected on this site. We only have access to/collect information
          that you voluntarily give us via email or other direct contact from you. We will not sell or rent this
          information to anyone.</p>
        <p>We will use your information to respond to you, regarding the reason you contacted us. We will not share your
          information with any third party outside of our organization, other than as necessary to fulfill your request,
          e.g. to ship an order.</p>
        <p>Unless you ask us not to, we may contact you via email in the future to tell you about specials, new products
          or services, or changes to this privacy policy.</p>
        <p>Your Access to and Control Over Information</p>
        <p>You may opt out of any future contacts from us at any time. You can do the following at any time by
          contacting us via the email address or phone number given on our website:</p>
        <p>See what data we have about you, if any.</p>
        <p>Change/correct any data we have about you.</p>
        <p>Have us delete any data we have about you.</p>
        <p>Express any concern you have about our use of your data.</p>
        <p>Security</p>
        <p>We take precautions to protect your information. When you submit sensitive information via the website, your
          information is protected both online and offline.</p>
        <p>Wherever we collect sensitive information (such as credit card data), that information is encrypted and
          transmitted to us in a secure way. You can verify this by looking for a closed lock icon at the bottom of your
          web browser, or looking for "https" at the beginning of the address of the web page.</p>
        <p>While we use encryption to protect sensitive information transmitted online, we also protect your information
          offline. Only employees who need the information to perform a specific job (for example, billing or customer
          service) are granted access to personally identifiable information. The computers/servers in which we store
          personally identifiable information are kept in a secure environment.</p>
        <p>If you feel that we are not abiding by this privacy policy, you should contact us immediately via telephone
          at 626-995-1188 or via email.</p>
      </el-dialog>
    </div>
    <!--end提示框-->
    </el-form>
    <div class="Bestsellers" :style="'margin-bottom: 35px;'" v-if="this.list.length > 0">
      <div class="page-width">
        <div class="padding">
          <!-- <div class="text-center">
            <h2 class="kitkat-header">WOW, KIT KATS direct from Nestle Japan!</h2>
            <p :style="'font-size: 16px; margin-bottom: 10px;'">Exclusive offer of Kit Kats now on sale for a limited time only until supplies last. Get yours now!!</p>
          </div> -->
          <swiper :options="productSwiper" ref="mySwiper">
            <swiper-slide v-for="(p, index) in this.list" :key="index" v-if="!p.IsStopSale">
              <productCard v-if='$i18n.locale=="en"'
                v-bind:img="p.ThumbnailLarge"
                v-bind:link="p.link"
                v-bind:name="p.Name"
                v-bind:isPromotion="p.isPromotion"
                v-bind:price="p.Price"
                v-bind:item="p"
                v-bind:quantity="p.Quantity"
                v-bind:key="index"
              ></productCard>
              <productCard v-if='$i18n.locale=="ch"'
                v-bind:img="p.ThumbnailLarge"
                v-bind:link="p.link"
                v-bind:name="p.Description"
                v-bind:isPromotion="p.isPromotion"
                v-bind:price="p.Price"
                v-bind:item="p"
                v-bind:quantity="p.Quantity"
                v-bind:key="index"
              ></productCard>
            </swiper-slide>
          </swiper>
            <div v-if="this.list.length>5" class="swiper-button-prev swp1"></div>
            <div v-if="this.list.length>5" class="swiper-button-next swp1"></div>
        </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import moment from "moment";
import axios from 'axios';
import _ from 'lodash';

import { validateZipCode, validatePhoneNumber } from "../../config/validation";
import productCard from "./productCard";
import alcoholModal from './Modal/alcoholModal';
import errorModal from './Modal/errorModal';
import addresses from '../store/modules/addresses';
import { CUSTOMER_INFORMATION_URL, SAVE_PAYPAL_DATA, ROOT_URL} from '../api/url';
import cart, { isUserAuthenticated } from "../store/modules/cart";

export default {
  name: "purchase",
  components: {
    productCard,
    errorModal,
    alcoholModal
  },
  data() {
    // this function detects if a string is composed solely of numbers.
    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }
    // phone validation
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input a phone number'));
      } else if (!isNumeric(value)) {
        callback(new Error('Phone number must be composed of only numbers.'));
      } else {
        if (this.sizeForm.phone !== '') {
          this.$refs.sizeForm.validateField('phone');
        }
        callback();
      }
    };
    return {
      paymentTerm: '',
      scrollPosition: null,
      list: [],
      shipstation:'',
      accordionOpen: 'accordion',
      labelPosition: 'top',
      address: '',
      promoCode: '',
      card_holder_name: '',
      addressChoice: '',
      order: false,
      radio: '',//单选框默认
      deliveryTime: '',
      creditCardSuccess: false,
      showPaymentError: false,
      paymentMethod: 'creditcard',
      activeNames: ['1'],
      Subtotal:15,
      total:15,
      billingAddress: '',
      billingAddressSame: true,
      isAddBankInfo: false,
      isAddBankForm: false,
      addressSelection: null,
      // form default data
      sizeForm: {
        name: "",
        subscribe: true,
        firstName: '',
        lastName: '',
        address: '',
        apartment: '',
        city: '',
        code: '',
        phone: '',
        Country: 'United States',
        State: '',
        gateCode: '',
        whether: 1,
        confirmAddress: '',
        Card: '', // card number
        Expiration: '',
        CVC: '',
        storage: true,
        card_holder_name: '',
        bankName: '',
        account: '',
        routing: ''
      },
      cardName: false,
      cardCvc: false,
      cardExpiry: false,
      cardNum: false,
      bankForm: {
        name: '',
        routing: '',
        account: '',
      },
      bankName: false,
      routing: false,
      account: false,
      bankRouting: false,
      bankAccountNum: false,
      bankProfile: null,
      achChoice: null,
      existingBankId: null,
      productSwiper: {
        slidesPerView: 4,
        navigation: {
          nextEl: '.swiper-button-next.swp1',
          prevEl: '.swiper-button-prev.swp1',
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
          },
          //when width >= 480
          480:{
            slidesPerView: 2,
          },
          767: {
            slidesPerView: 2,
          },
          //when width >= 640
          990: {
            slidesPerView: 3,
          },
          1200:{
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 4,
          }
        }
      },
      cardData: {
        cardNumber: null,
        expiry: null,
        cvc: null,
        // cardType: null,
        CardName: null,
        salesOrderId: null,
      },
      rules:{
        firstName:[
          { required: true, message: 'First Name is Required', trigger: 'blur' },
          { min: 2, max: 20, message: 'first name length at least 3', trigger: 'blur' }
        ],
        lastName:[
          { required: true, message: 'Last Name is Required', trigger: 'blur' },
          { min: 2, max: 20, message: 'last name length at least 3', trigger: 'blur' }
        ],
        address:[
          { required: true, message: 'Address is required', trigger: 'blur' },
          { min: 2, max: 30, message: 'address length at least 3', trigger: 'blur' }
        ],
        city:[
          { required: true, message: 'City is Required', trigger: 'blur' },
          { min: 3, max: 20, message: 'city length at least 3', trigger: 'blur' }
        ],
        code:[
          { required: true, message: 'Zip Code is Required', trigger: 'blur' },
          { min: 3, max: 5, message: 'code length at least 3', trigger: 'blur' }
        ],
        phone:[
          { required: false, message: 'Phone Number is Required', trigger: 'blur' },
          { min: 3, max: 12, message: 'Phone must be between 3 and 12 digits.', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        Country:[
          { required: true, message: 'Country is Required', trigger: 'blur' },
          { min: 3, max: 20, message: 'Country length at least 3', trigger: 'blur' }
        ],
        Card:[
          { required: true, message: 'Card Info is Required', trigger: 'blur' },
          { min: 16, max: 23, message: 'Card number should be 13 - 19 digits', trigger: 'blur' },
        ],
        Expiration:[
          { required: true, message: 'Expiration Date is Required', trigger: 'blur' },
          { min: 5, max: 5, message: 'Expiration data shoud be in format MM/YY', trigger: 'blur' }
        ],
        CVC:[
          { required: true, message: 'Security Code is Required', trigger: 'blur' },
          { min: 3, max: 4, message: 'CVC length at least 3', trigger: 'blur' }
        ],
        routing: [
          { required: true, message: "Routing Number is Required", trigger: "blur"},
          { min: 9, max: 9, message: "Must be 9 Digits in Length", trigger: "blur"},
        ],
        account: [
          { required: true, message: "Account Number is Required", trigger: "blur" },
          { min: 5, message: "Account Number Length Must Be More Than 4", trigger: "blur"},
        ],
        bankName: [
          { required: true, message: 'Account Name is Required', trigger: 'blur' },
          { min: 2, max: 22, message: "Account Name Length Must Be More Than 2 but less than 22", trigger: "blur"}
        ]
      },
      // drop down default data
      stateOptions: this.$store.state.addresses.states, // States drop down data
      CountryList:[{
        value: '',
        label: '---'
      }, {
        value: 'United States',
        label: 'United States'
      }],
      // input label
      input_label: false,
      firstName: false,
      lastName: false,
      addressName: '',
      apartment: false,
      city: false,
      code: false,
      phone: false,
      privacy: false,
      refund: false,
      // 商品列表默认数据
      isAddAddress: false,
      isAddPayment: false,
      isAddBilling: false,
      paypalRendered: false,
      payPalSuccessful: false,
      payPalLoading: false,
      paypalError: '',
      shippingInfoModalOpen: false,
      shippingInfoModalIdx: 0,
      IsCreditUsed: false,
      disableAlcohol: false,
      alcoholItemsToBeRemoved: [],
      paypalValidationError: false,
      paypalValidationErrorMsg: '',
      alcoholLoading: false,
      receivingWay: this.$t('delivery'),
      shippingMethod: 'Delivery',
    }
  },
  methods: {
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapActions('products', ['fetchCategories']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard', 'updatePromoCode', 'resetShipstationData', 'orderSuccessful', 'b2bReset', 'clearPromo', 'orderReset', 'toggleAlcoholModal']),
    ...mapActions('checkout', ['savePayPalData', 'fetchAchProfiles']),
    cardNumberFormatter(value) {
      var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
      var matches = v.match(/\d{4,19}/g);
      var match = matches && matches[0] || ''
      var parts = []

      for (var i=0, len=match.length; i<len; i+=4) {
          parts.push(match.substring(i, i+4))
      }
      if (parts.length) {
          this.sizeForm.Card =  parts.join(' ')
      } else {
          this.sizeForm.Card = value
      }
    },
    cardExpireDateFormatter(date) {
      if(date.length == 3) {
        if(date[date.length - 1] !== '/') {
          var temp =  this.sizeForm.Expiration.split('');
          temp.splice(2, 0, '/');
          this.sizeForm.Expiration = temp.join('');
          return;
        }else {
          this.sizeForm.Expiration = this.sizeForm.Expiration.slice(0, 2);
        }
      }
    },
    findServiceSurchage() {
      let cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
      cartItems.PromoCode = this.PromoCode;
      cartItems.IsCreditUsed = this.IsCreditUsed;
      if (this.shippingMethod === 'Delivery') {
        cartItems.ShippingMethod = "Delivery";
        cartItems.Zip = this.addressSelection ? this.addressSelection.Zip : '';
        cartItems.Delivery = this.shipstation.shipmentCost + this.shipstation.otherCost;
      } else {
        cartItems.ShippingMethod = "Will Call";
        cartItems.Delivery = 0;
      }
      if ((this.paymentMethod === 'paypal' || this.paymentMethod === 'creditcard') && this.business) {
        cartItems.b2bsurcharge = true;
      }
      return this.$store.dispatch('cart/saveAndAdjustCart', cartItems);
    },
    contact(el) {
      this.sizeForm.name !== '' ? this.input_label = true : this.input_label = false;
      this.sizeForm.firstName !== '' ? this.firstName = true : this.firstName = false;
      this.sizeForm.lastName !== '' ? this.lastName = true : this.lastName = false;
      this.sizeForm.address !== '' ? this.address = true : this.address = false;
      this.sizeForm.city !== '' ? this.city = true : this.city = false;
      this.sizeForm.code !== '' ? this.code = true : this.code = false;
      this.sizeForm.phone !== '' ? this.phone = true : this.phone = false;
      this.sizeForm.card_holder_name !== '' ? this.cardName = true : this.cardName = false;
      this.sizeForm.CVC !== '' ? this.cardCvc = true : this.cardCvc = false;
      this.sizeForm.Expiration !== '' ? this.cardExpiry = true : this.cardExpiry = false;
      this.sizeForm.Card !== '' ? this.cardNum = true : this.cardNum = false;
      this.sizeForm.bankName !== '' ? this.bankName = true : this.bankName = false;
      this.sizeForm.account !== '' ? this.account = true : this.account = false;
      this.sizeForm.routing !== '' ? this.routing = true : this.routing = false;
    },
    updateScroll() {
      this.scrollPosition = this.$refs.infoBox.clientHeight - window.scrollY;
    },
    validateScrollPosition() {
      if (this.scrollPosition <= '-110') { return ''; }
      else { return ''; }
    },
    refundShow() {
      this.refund = !this.refund;
    },
    closeErrorModal() {
      this.orderReset();
    },
    removePromo(e) {
      e.preventDefault();
      this.clearPromo();
    },
    clearAlcoholItems() {
      this.alcoholLoading = true;
      let cartItems = this.cartProductsList && this.cartProductsList.Sales_Order_Lines;
      cartItems.map(item => {
        if (item.IsAlcohol) {
          this.$store.dispatch('cart/deleteCartItem', item.Product_id)
        }
      });
      this.alcoholLoading = false;
      if (!this.alcoholLoading) {
        this.$store.dispatch('cart/getCart')
        .then(() => {
          const that = this;
          setTimeout(function(item, event) {
            that.toggleAlcoholModal(false);
          }, 500)
        })
      }
    },
    checkForAlcohol(address) {
      let cartItems = this.cartProductsList && this.cartProductsList.Sales_Order_Lines
      if (address.State !== 'CA') {
        cartItems.map(item => {
          if (item.IsAlcohol) {
            this.disableAlcohol = true;
            if (!this.alcoholItemsToBeRemoved.includes(item)) {
              this.alcoholItemsToBeRemoved.push(item);
            }
          }
        });
      }
    },
    getAddress() {
      this.addresses.map(address => {
        if (address.CustomerDetail_id === this.addressChoice) {
          this.addressSelection = address;
          this.checkForAlcohol(address);
        }
      })
    },
    validatePromotionCode(e) {
      e.preventDefault();
        this.$store.dispatch('checkout/validatePromoCode', [this.promoCode, this.TotalPrice])
        .then(() => {
        let cartItems = {};
        cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
        cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        cartItems.Tip = 0;
        cartItems.TipPercentage = 0;
        cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
        cartItems.PromoCode = this.PromoCode;
        cartItems.IsCreditUsed = this.IsCreditUsed;
        if (this.shippingMethod === 'Delivery') {
          cartItems.ShippingMethod = "Delivery";
          cartItems.Zip = this.addressSelection ? this.addressSelection.Zip : '';
          cartItems.Delivery = this.shipstation.shipmentCost + this.shipstation.otherCost;
        } else {
          cartItems.ShippingMethod = "Will Call";
          cartItems.Delivery = 0;
        }
        if ((this.paymentMethod === 'paypal' || this.paymentMethod === 'creditcard') && this.business) {
          cartItems.b2bsurcharge = true;
        }
        cartItems.Zip = this.addressSelection.Zip
        this.$store.dispatch('cart/saveAndAdjustCart', cartItems);
        this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
      })
    },
    paymentMethod: "",
    savings: 0,
    GrandTotal: 0,
    activeNames: ['1'],
    Subtotal:15,
    total:15,
    sizeForm: {
      name: "",
      subscribe: true,
      firstName: '',
      lastName: '',
      address: '',
      apartment: '',
      city: '',
      code: '',
      phone: '',
      Country: '',
      State: '',
      gateCode: '',
      whether: 1,
      confirmAddress: '',
      Card: '',
      Expiration: '',
      CVC: '',
      storage: true,
    },
    cardData: {
      cardNumber: null,
      expiry: null,
      cvc: null,
      // cardType: null,
      CardName: null,
      salesOrderId: null,
    },
    checkForm: async function(form) {
      this.errors = [];
      if(!form.Street) {
        this.errors.push(this.$t('addressRequired'));
      };
      if(!form.City) {
        this.errors.push(this.$t('cityRequired'));
      };
      if(!form.Country) {
        this.errors.push(this.$t('countryRequired'));
      };
      if(!form.State) {
        this.errors.push(this.$t('stateRequired'));
      };
      if (validateZipCode(form.Zip)){
        this.errors.push(this.$t('zipCodeWrong'));
      };
      if (form.Telephone) {
        if (validatePhoneNumber(form.Telephone)){
          this.errors.push(this.$t('phoneNumberWrong'));
        };
      }
    },
    postNewAddress(form, type, event) {
      event.preventDefault();
      const address = {};
      address.Street = form.address;
      address.City = form.city;
      address.State = form.State;
      address.Zip = form.code;
      address.Country = form.Country;
      address.gateCode = form.gateCode;
      address.FirstName = form.firstName;
      address.LastName = form.lastName;
      address.Telephone = form.phone;
      if (type === 'billing') { address.Type = 'Billing' }
      this.checkForm(address);
      if (!this.errors.length) {
        this.$store.dispatch('addresses/postAddress', [address, type])
        .then(() => {
          this.isAddAddress = false;
          this.isAddBilling = false;
        })
      } else {
        alert(this.errors);
      }
    },
    onSubmit(sizeForm, paypal, checkOrder){
      let orderData = {};
      let time = moment()._d;
      if (this.BypassPayment) {
        orderData.PaymentMethod = "bypass";
      } else {
        orderData.PaymentMethod = this.paymentMethod;
      }
      orderData.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      orderData.FinalPrice = this.necessaryCartItems.FinalPrice;
      orderData.TotalPrice = this.necessaryCartItems.TotalPrice;
      orderData.GrandTotal = this.necessaryCartItems.GrandTotal;
      orderData.SalesOrder_id = this.salesOrderId;
      orderData.TimeSlot = time;
      orderData.terminal = this.device;
      // delivery time does not exist anymore.
      orderData.DispatchDate = this.deliveryTime;
      orderData.PromoCode = this.PromoCode || this.necessaryCartItems.PromoCode;
      orderData.Savings = this.Savings;
      orderData.serviceCode = this.shipstation.serviceCode;
      orderData.b2b = this.business;
      orderData.checkOrder = checkOrder;
      orderData.platform = "web";
      for (const key in this.necessaryCartItems) {
        if (!orderData.hasOwnProperty(key)) {
          orderData[key] = this.necessaryCartItems[key];
        }
      }
      if (this.shippingMethod === 'Delivery') {
        orderData.ShippingMethod = 'Delivery'
        orderData.Deliver_CustomerDetail_id = this.addressSelection.CustomerDetail_id;
        orderData.Billing_CustomerDetail_id = this.billingAddressSame ? this.addressSelection.CustomerDetail_id : this.billingAddress.CustomerDetail_id;
        orderData.Delivery = this.shipstation.shipmentCost + this.shipstation.otherCost;
      } else {
        orderData.ShippingMethod = 'Will Call'
      }
      if (this.paymentMethod === 'ACH') {
        if (this.existingBankId) {
          orderData.existingBankAccount = this.existingBankId;
        } else {
          let bankForm = {};
          bankForm.name = this.sizeForm.bankName;
          bankForm.account = this.sizeForm.account.toString()
          bankForm.routing = this.sizeForm.routing.toString();
          orderData.bankAccount = bankForm;
        }
      }
      if (paypal) {
        return this.$store.dispatch('checkout/submitOrderPriorToPayPal', orderData);
      } else {
        // users will be double-charged if the CC data is sent to paypal.
        orderData.card_reference = this.card_reference;
        this.$store.dispatch('checkout/submitOrder', orderData).then(() => {
          this.shipstation = ''
          setTimeout(() => {
            this.selectShipstation();
          }, 1000)
        });
      }
    },
    fetchCardToken() {
      let paymentData = {};
      paymentData.cardNum = this.sizeForm.Card.split(' ').join('')
      paymentData.expDate = '20' + this.sizeForm.Expiration.split("/").reverse().join("-");
      paymentData.cvv = this.sizeForm.CVC;
      paymentData.salesOrderId = this.salesOrderId;
      paymentData.card_holder_name = this.sizeForm.card_holder_name;
      // AC card check, keep it for now
      // this.$store.dispatch('checkout/fetchACCardToken', paymentData)
      this.$store.dispatch('checkout/saveCreditCard', paymentData);
      this.isAddPayment = false;
    },
    fetchBankInfo() {
      if (!this.achChoice) {
        if (this.sizeForm.bankName.length > 22) {
          return;
        }
        let bankForm = {};
        bankForm.name = this.sizeForm.bankName;
        bankForm.account = this.sizeForm.account;
        bankForm.routing = this.sizeForm.routing;
        this.$store.dispatch('checkout/saveBankInfo', bankForm)
        this.isAddBankInfo = false;
        this.isAddBankForm = false;
      } else {
        this.existingBankId = this.achChoice.id;
        this.isAddBankInfo = false;
        this.isAddBankForm = false;
      }
    },
    achSelected() {
      if (this.isAddBankForm) {
        this.isAddBankForm = false;
      } else {
        this.existingBankId = this.achChoice.id;
        // this.sizeForm.bankName = this.achChoice.name;
        // this.sizeForm.routing = this.achChoice.routing;
        // this.sizeForm.account = this.achChoice.account_num;
      }
    },
    addBankForm() {
      this.achChoice = null;
      this.isAddBankForm = !this.isAddBankForm;
    },
    submitOrder(paymentData) {
      paymentData.card_reference = this.card_reference;
      this.$store.dispatch('checkout/submitOrder', paymentData);
    },
    validateAddress() {
      this.$store.dispatch('navbar/validateDeliveryRadius');
    },
    validateDeliveryRadiusCheckout(event) {
      this.$store.dispatch('navbar/validateDeliveryRadius', this.addressSelection.Zip);
      // this.selectShipstation();
    },
    addAddress(priorAddress) {
      this.isAddAddress = !this.isAddAddress;
    },
    addBilling() {
      this.isAddBilling = !this.isAddBilling;
      if (this.billingAddress) {
        this.billingAddress = '';
      }
    },
    addPayment() {
      if (!this.isAddPayment) {
        this.isAddPayment = true;
      } else if (this.isAddPayment && !this.validateCardForm()) {
        this.isAddPayment = false;
      }
    },
    addBank() {
      this.isAddBankInfo = !this.isAddBankInfo;
    },
    validateCardForm() {
      return (!this.cardName || !this.cardCvc || !this.cardExpiry || !this.cardNum);
    },
    validateBankInfo() {
      return true;
    },
    isFormValidForSubmission() {
      let valid = false;
      if (this.paymentMethod === 'creditcard') {
        if (this.cardSuccess) {
          valid = true;
        } else {
          valid = false
        }
      } else if (this.paymentMethod === 'wechatpay' || this.paymentMethod === 'alipay' || this.paymentMethod === "bypass") {
        valid = true;
      } else if (this.paymentMethod === 'ACH') {
        if ((!this.achChoice) && (!this.existingBankId) && (!this.sizeForm.bankName || !this.sizeForm.routing || !this.sizeForm.account)) {
          valid = false;
        } else if (this.isAddBankForm) {
          valid = false;
        } else {
          valid = true;
        }
      }
      if (this.addressChoice === '' || (!this.billingAddress && !this.billingAddressSame)) {
        valid = false;
      }
      if (this.orderLoading || this.cardLoading || this.windowOpening) {
        valid = false;
      }
      if (!this.$store.state.cart.cartProductsList.Sales_Order_Lines || !this.$store.state.cart.cartProductsList.Sales_Order_Lines.length) {
        valid = false;
      }
      if (this.paymentMethod === '') {
        if (!this.BypassPayment) {
          valid = false;
        } else {
          valid = true;
        }
      }
      if (!this.shipstation || this.shipstationLoading) {
        if (!this.b2bOverweight) {
          valid = false;
        }
      }
      //如果是自取
      if(this.receivingWay == 'Pick Up' || this.receivingWay == '自取'){
        valid=true;
      }
      return valid;
    },
    goToProductDetail(product) {
      if (this.business) {
        let num = product.ProductNum;
        if (num.charAt(num.length - 1) === '0' || num.charAt(num.length - 1) == '2') {
          let singleNum = product.ProductNum.slice(0, -1) + "1";
          this.updateActiveProduct(singleNum);
          this.$router.push({
            name: 'productDetails',
            query: { productNum: singleNum
          }})
        }
      } else {
        this.updateActiveProduct(product.ProductNum);
        this.$router.push({
          name: 'productDetails',
          query: { productNum: product.ProductNum }
        });
      }
    },
    selectShipstation(e, item) {
      let cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
      cartItems.PromoCode = this.PromoCode;
      if (this.shippingMethod === 'Delivery') {
        cartItems.ShippingMethod = "Delivery";
        cartItems.Zip = this.addressSelection ? this.addressSelection.Zip : '';
        cartItems.Delivery = this.shipstation.shipmentCost + this.shipstation.otherCost;
      } else {
        cartItems.ShippingMethod = "Will Call";
        cartItems.Delivery = 0;
      }
      if ((this.paymentMethod === 'paypal' || this.paymentMethod === 'creditcard') && this.business) {
        cartItems.b2bsurcharge = true;
      }
      this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
      .then( () => {
        this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
      })
    },
    productTitle(item) {
      if (!this.business) {
        return item.Name;
      }
      if (this.business) {
        if (item.ProductNum.charAt(item.ProductNum.length -1) === '0') {
          return item.Name + ' (Master Case)';
        }
        if (item.ProductNum.charAt(item.ProductNum.length -1) === '2') {
          return item.Name + ' (Inner Case)';
        } else {
          return item.Name;
        }
      }
    },
    isB2B() {
      const token = localStorage.getItem('token');
      const config = {
        method: 'get',
        url: CUSTOMER_INFORMATION_URL,
        headers: {
          Authorization: `JWT ${token}`,
        }
      };
      let b2b = axios(config)
      .then( (res) => {
        this.paymentTerm = res.data.PaymentTerm;
        return res.data.IsBusiness;
      })
      return b2b;
    },
    clearCreditCardForm() {
      this.sizeForm.Card = '';
      this.sizeForm.Expiration = '';
      this.sizeForm.CVC = '';
      this.sizeForm.card_holder_name = '';
    },
    //改变收货方式
    changeReceivingWay(value){
      this.shippingMethod = value;
      this.$nextTick(() => {
        this.selectShipstation();
      });
    }
  },
  mounted() {
    var PAYPAL_SCRIPT = 'https://www.paypal.com/sdk/js?client-id=ASRnmYBq9R1cx518ImZVFOTxBLgdOp4rMJWVbjZAb2BMq1oCVxKF6C4JfjL_JYgyMEfLvQpWW_P4elxV&disable-funding=credit,card';
    var script = document.createElement('script');
    // if ( ROOT_URL === 'https://afgstage-scm.truckxi.com/api') {
    //   // PayPal sandbox client ID:
    //   PAYPAL_SCRIPT = 'https://www.paypal.com/sdk/js?client-id=Ads1uxTsKczGUJpmTuDfCOwV3TvoCqMVG8a6CaK4a4qAI1BKq2l8ITukK0VubMBTsZO99sGtl4Iozq72&disable-funding=credit,card';
    // }
    script.setAttribute('src', PAYPAL_SCRIPT);
    document.head.appendChild(script);
    window.addEventListener('scroll', this.updateScroll);
    if (isUserAuthenticated()) {
      this.isB2B()
      .then( (res) => {
        this.fetchCategories([9, res])
        .then( (res) => {
          this.list = res.data;
        })
      });
    }
  },
  beforeMount() {
    this.$store.dispatch('cart/getCart')
    .then(() => {
      const cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.ShippingMethod = "Delivery";
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
      this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
      .then(() => {
        this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
      })
    })
    this.$store.dispatch('addresses/fetchAddresses');
  },
  watch: {
    IsCreditUsed: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        let cartItems = {};
        cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
        cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        cartItems.Tip = 0;
        cartItems.TipPercentage = 0;
        cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
        cartItems.IsCreditUsed = this.IsCreditUsed;
        if (this.shippingMethod === 'Delivery') {
          cartItems.ShippingMethod = "Delivery";
          cartItems.Zip = this.addressSelection ? this.addressSelection.Zip : '';
          cartItems.Delivery = this.shipstation.shipmentCost + this.shipstation.otherCost;
        } else {
          cartItems.ShippingMethod = "Will Call";
          cartItems.Delivery = 0;
        }
        if ((this.paymentMethod === 'paypal' || this.paymentMethod === 'creditcard') && this.business) {
          cartItems.b2bsurcharge = true;
        }
        this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
        .then( () => {
          this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
        })
      }
    },
    isAddAddress: function (newVal, oldVal) {
      immediate: true;
      if (newVal === true && oldVal === false) {
        this.addressChoice = '';
        this.addressSelection = '';
      }
    },
    addressChoice: function(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== '') {
        this.getAddress();
        // reset the error message for payment
        let shipstationData = {};
        this.shipstation = '';
        shipstationData.tozip = this.addressSelection.Zip;
        shipstationData.business = this.business;
        shipstationData.SalesOrder_id = this.salesOrderId;
        this.showPaymentError = false;
        if (newVal !== oldVal && !this.isAddBilling) {
          this.addresses.map(address => {
            if (address.CustomerDetail_id === this.addressSelection.CustomerDetail_id) {
              this.addressName = address.FirstName + ' ' + address.LastName;
            }
          });
          // this.selectShipstation();
        };
        if (oldVal === '' && newVal !== oldVal && !this.isAddBilling) {
          this.isAddAddress = false;
        }
        if (!this.isAddBilling) {
          this.$store.dispatch('checkout/fetchShipStationPrices', shipstationData);
        }
      }
    },
    cardLoading: function(newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        this.isAddPayment = false;
      }
    },
    promoCodeSuccessful: function(newVal, oldVal) {
      if (newVal === true) {
       let value = ((this.TotalPrice - this.Savings.toFixed(2)) + this.necessaryCartItems.Tax + this.necessaryCartItems.Delivery).toFixed(2);
       this.saveGrandTotal(Number(value));
      }
    },
    necessaryCartItems: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updatePromoCode(this.necessaryCartItems.Savings);
      }
    },
    cartProductsList: {
      deep: true,
      handler(newVal) {
        if (newVal && this.$route.name === 'purchase') {
          const cartItems = {};
          cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
          cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
          cartItems.Tip = 0;
          cartItems.TipPercentage = 0;
          cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
          if (this.shippingMethod === 'Delivery') {
            cartItems.ShippingMethod = "Delivery";
            cartItems.Zip = this.addressSelection ? this.addressSelection.Zip : '';
            cartItems.Delivery = this.shipstation.shipmentCost + this.shipstation.otherCost;
          } else {
            cartItems.ShippingMethod = "Will Call";
            cartItems.Delivery = 0;
          }
          this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
          .then(() => {
            this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
          });
          this.resetShipstationData();
          // this.addressChoice = '';
          this.clearPromoCode();
          this.clearCard();
          this.paymentMethod = '';
          this.IsCreditUsed = false;
          this.paypalValidationError = false;
          this.paypalValidationErrorMsg = '';
          this.b2bReset();
        }
      }
    },
    shipstationResults: function(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        if (newVal.length === 1) {
          this.shipstation = newVal[0];
          this.selectShipstation();
        }
      }
    },
    paypalError: function(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        // alert("PayPal Error:", newVal); //temporary
        alert("PayPal Error: Please clear your browser cache. (For Safari, enable developer mode Preferences/Advanced Tab)");
      }
    },
    paypalPaymentError: function(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        alert("Error:", newVal);
      }
    },
    shipstationLoading: function(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.paymentMethod = '';
      }
    },
    // This watcher is handling the PayPal functionality. Keep that in mind if you change it.
    // Paypal logic: Click Paypal button => Submit SCM order => Complete Paypal payment => Send Backend Paypal payment info.
    paymentMethod: function(newVal, oldVal) {
      let that = this;
      let ele = document.querySelector('#paypal-button-container');
      if (newVal === 'paypal' && newVal !== oldVal) {
        if (this.business) {
          this.findServiceSurchage()
          .then(res => {
            that.onSubmit(null, true, true).then(response => {
              this.paypalValidationError = false;
              this.paypalValidationErrorMsg = '';
            })
            .catch(err => {
              this.paypalValidationError = true;
              this.paypalValidationErrorMsg = err.response.data.message;
            })
          })
        } else {
          that.onSubmit(null, true, true).then(response => {
            this.paypalValidationError = false;
            this.paypalValidationErrorMsg = '';
          })
          .catch(err => {
            this.paypalValidationError = true;
            this.paypalValidationErrorMsg = err.response.data.message;
          })
        }
      }
      if (newVal === 'paypal' && newVal !== oldVal && !this.paypalRendered) {
        ['#button-1', '#button-2'].forEach(function(selector) {
          paypal.Buttons({
            onClick: function(data, actions) {
              return that.onSubmit(null, true, false)
                .then(response => {
                  return actions.resolve();
                })
                .catch(err => {
                  alert(err.response.data.message)
                  return actions.reject();
                })
            },
            createOrder: function(data, actions) {
              that.payPalLoading = true;
              return actions.order.create({
                purchase_units: [
                  {
                    "custom_id": that.salesOrderId,
                    "amount": {
                      "currency_code": "USD",
                      "value": that.finalPayPalPrice,
                    }
                  }
                ]
              })
            },
            onApprove: function(data, actions) {
              return actions.order.capture().then(function(details) {
                that.payPalSuccessful = true;
                that.payPalLoading = false;
                that.savePayPalData([that.salesOrderId, details])
              })
            },
            onError: function(err) {
              that.payPalSuccessful = false;
              that.payPalLoading = false;
              that.paypalError = err;
            },
            onCancel: function(data, actions) {
              that.payPalLoading = false;
            },
          }).render(selector)
        });
        this.paypalRendered = true;
      } else if (newVal === 'paypal' && newVal !== oldVal && this.paypalRendered) {
        const el = this.$el.querySelector('#paypal-button-container')
        if (el) {
          el.style.display = 'inline-block';
        }
      } else {
        if (newVal === 'ACH' && newVal !== oldVal) {
          if (this.addresses.length) {
            let id = this.addresses[0].Customer_id
            this.fetchAchProfiles(id)
            this.findServiceSurchage();
          }
        } else if (newVal !== oldVal && this.business) {
          this.findServiceSurchage();
        } else {
          const el = this.$el.querySelector('#paypal-button-container')
          if (el) {
            el.style.display = 'none';
          }
        }
      }
    },
    billingAddressSame: function(newVal, oldVal) {
      if (!newVal && newVal !== oldVal) {
        this.billingAddress = '';
      }
    },
    disableAlcohol: function(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.toggleAlcoholModal(true);
      }
    },
    alcoholModalVisible: function(newVal, oldVal) {
      if (newVal !== oldVal && !newVal) {
        this.disableAlcohol = false;
      }
      if (newVal !== oldVal && newVal) {
        this.resetShipstationData();
        this.addressChoice = '';
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('cart/getCart')
    .then(() => {
      const cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.ShippingMethod = "Delivery";
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
      this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
      .then(() => {
        this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
      })
    })
    this.clearPromoCode();
    this.clearCard();
    this.clearCreditCardForm();
    this.resetShipstationData();
    this.addressChoice = '';
    this.paymentMethod = '';
    this.IsCreditUsed = false;
    this.paypalRendered = false;
    this.payPalSuccessful = false;
    this.paypalValidationError = false;
    this.paypalValidationErrorMsg = '';
    next();
  },
  computed: mapState({
    salesOrderId: state => state.cart.cartProductsList.SalesOrder_id,
    card_reference: state => state.checkout.card_reference,
    timeSlots: state => state.checkout.timeSlots,
    addresses: state => state.addresses.customerDetails,
    customerDetails: state => state.profile.customerDetails,
    necessaryCartItems: state => state.cart.necessaryCartItems,
    cartProductsList: state => state.cart.cartProductsList,
    device: state => state.navbar.device,
    orderLoading: state => state.checkout.orderLoading,
    orderSuccessful: state => state.checkout.orderSuccessful,
    cardLoading: state => state.checkout.cardLoading,
    cardSuccess: state => state.checkout.cardSuccess,
    cardError: state => state.checkout.cardError,
    checkoutWithinRadius: state => state.navbar.checkoutWithinRadius,
    promoCodeLoading: state => state.checkout.promoCodeLoading,
    promoCodeSuccessful: state => state.checkout.promoCodeSuccessful,
    promoCodeError: state => state.checkout.promoCodeError,
    promoCodeValid: state => state.checkout.promoCodeValid,
    PromoCode: state => state.checkout.PromoCode,
    Savings: state => state.checkout.Savings,
    GrandTotal: state => state.checkout.GrandTotal,
    TotalPrice: state => state.checkout.TotalPrice,
    Tax: state => state.checkout.Tax,
    cartClicked: state => state.cart.cartClicked,
    itemCount: state => state.cart.itemCount,
    windowOpening: state => state.checkout.windowOpening,
    orderFailed: state => state.checkout.orderFailed,
    orderFailMessage: state => state.checkout.orderFailMessage,
    shipstationResults: state => state.checkout.shipstationResults,
    shipstationSuccess: state => state.checkout.shipstationSuccess,
    shipstationLoading: state => state.checkout.shipstationLoading,
    business: state => state.auth.userDetails.IsBusiness,
    userDetails: state => state.auth.userDetails,
    weight: state => state.cart.weight,
    BypassPayment: state => state.auth.userDetails.BypassPayment,
    shipstationError: state => state.checkout.shipstationError,
    finalPayPalPrice() {
      let subtotal = this.necessaryCartItems.TotalPrice;
      let tax = this.necessaryCartItems.Tax;
      let delivery = this.necessaryCartItems.Delivery;
      let promo = this.necessaryCartItems.Savings;
      let surcharge = this.necessaryCartItems.Surcharge || 0;
      let credit = this.IsCreditUsed ? this.necessaryCartItems.CreditAmount : 0;
      let total = subtotal + tax + delivery - promo + surcharge - credit;
      return total.toFixed(2).toString();
    },
    windowWidth: state => state.navbar.windowWidth,
    paypalPaymentError: state => state.checkout.paypalPaymentError,
    b2bOverweight: state => state.checkout.b2bOverweight,
    achLoading: state => state.checkout.achLoading,
    achData: state => state.checkout.achData,
    achError: state => state.checkout.achError,
    tag: state => state.checkout.tag,
    alcoholModalVisible: state => state.checkout.alcoholModalVisible
  }),
}
</script>

<style lang="less">
@import "../assets/css/purchase.less";
@import "../assets/css/animation.less";
@import "../assets/css/shippingModal.less";
</style>



// WEBPACK FOOTER //
// src/view/purchase.vue